import * as TYPE from './actionType.js';

export function deliveryData(deliveryData) {
  return { type: TYPE.DELIVERYDATA, data: deliveryData };
}
